var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSatoshi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 402,
    height: 402,
    viewBox: "0 0 402 402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1835.418,3573.418c-108.248,0-196,87.752-196,196a196.045,196.045,0,0,0,119.092,180.327q4.157,1.778,8.414,3.361l158.961-92.212c38.906-22.462,38.906-78.618,0-101.08l-54.94-31.72,70.346-40.614-35.619-20.566-105.968,61.18,106.86,61.694a23.747,23.747,0,0,1,0,41.13l-141.8,82.226-.039.229a160.4,160.4,0,0,1,95.2-302.461l-.139.081-115.025,66.726c-38.906,22.462-38.906,78.619,0,101.079l54.939,31.72-71.064,41.03,35.62,20.564,106.683-61.594-106.858-61.694a23.747,23.747,0,0,1,0-41.131l141.789-82.353a160.377,160.377,0,0,1-70.459,304.443v35.632c108.248,0,196-87.752,196-196S1943.666,3573.418,1835.418,3573.418Z",
    transform: "translate(-1634.418 -3568.418)",
    stroke: "#fff",
    strokeWidth: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatoshi);
export default __webpack_public_path__ + "static/media/satoshi.d2b9024c5cc2d204803efe4ae97e2211.svg";
export { ForwardRef as ReactComponent };